<mat-form-field class="input-field city-select">
  <input type="text" matInput [formControlName]="formControlName" placeholder="City" [matAutocomplete]="city" [(ngModel)]="selectedValue" (ngModelChange)="getCityName()" (focusout)="validateCity($event)">
  <mat-autocomplete #city='matAutocomplete' class="city-select">
    <mat-option class="city-select" *ngFor="let value of filteredCities"
                    [value]="value">
            {{ value }}
        </mat-option>
  </mat-autocomplete>
  <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>